import { apiCall, publicApiCall } from "./base";

export type StudioAccessStatus =
  "approved" | "pending" | "rejected" | "inactive" | "not_requested";

export interface StudioPolicy {
  termsVersion: string;
  privacyVersion: string;
  termsUrl: string;
  privacyUrl: string;
}

export interface StudioPolicyConsent {
  accepted: true;
  termsVersion: string;
  privacyVersion: string;
}

export interface AccessStatusResponse {
  accessStatus: StudioAccessStatus;
  role: "super_admin" | "tenant_admin" | "user" | "guest" | null;
  permissionScope: "full" | "guest_sample" | "none";
  consentRequired?: boolean;
  policy?: StudioPolicy | null;
  tenantId?: string | null;
  /** Admin에 등록된 고객사명. 미배정 요청과 tenant 없는 상태에서는 null이다. */
  tenantName?: string | null;
  request: {
    id: string;
    email: string;
    authType: "company" | "social";
    provider: string;
    authProvider?:
      "unresolved" | "password" | "google" | "microsoft" | "apple" | null;
    identityClaimRequired?: boolean;
    status: "pending" | "approved" | "rejected";
    requestedAt: string;
    resolvedAt?: string | null;
  } | null;
}

export const getAccessStatus = async (): Promise<AccessStatusResponse> =>
  apiCall("/api/access/status") as Promise<AccessStatusResponse>;

export const createAccessRequest = async (
  email?: string,
  consent?: StudioPolicyConsent,
): Promise<AccessStatusResponse> =>
  (email
    ? publicApiCall("/api/access/requests", {
        method: "POST",
        body: JSON.stringify({ email }),
      })
    : apiCall("/api/access/requests", {
        method: "POST",
        ...(consent && { body: JSON.stringify({ consent }) }),
      })) as Promise<AccessStatusResponse>;

export const studioPolicyConsent = (
  policy: StudioPolicy,
): StudioPolicyConsent => ({
  accepted: true,
  termsVersion: policy.termsVersion,
  privacyVersion: policy.privacyVersion,
});
